import React from "react";

function Unauthorised() {
    return (
        <div className="container">
            <div className="vertical-center justify-content-center unauthorized_text">
                <h5>You are currently not set up to use this System.</h5>
                <h5>If you are a clinician, your profile has not been created.</h5>
                <h5>
                    If you are an admin staff, your permissions have not been set up
                    correctly.
                </h5>
                <h5>Please contact the intake team or tech support.</h5>
            </div>
        </div>
    );
}

export default Unauthorised;
